@if (visible) {
  <div class="trial-banner" [class.trial-banner--urgent]="trialState === 'expiring' || trialState === 'expired'">
    @if (trialState === 'expired') {
      @if (accountType === UserModuleTypeEnum.PAID) {
        <span class="trial-banner__badge">{{ 'tenders.responses.trial-banner.badge-expired-paid' | translate }}</span>
      } @else {
        <span class="trial-banner__badge">{{ 'tenders.responses.trial-banner.badge-expired-trial' | translate }}</span>
      }
      <span class="trial-banner__text">
        @if (accountType === UserModuleTypeEnum.PAID) {
          {{ 'tenders.responses.trial-banner.text-expired-paid' | translate }},
        } @else {
          {{ 'tenders.responses.trial-banner.text-expired-main' | translate: { plan: planLabel } }},
        }
        <a class="trial-banner__text-link" [href]="mailtoHref" target="_blank">{{
          'tenders.responses.trial-banner.cta-link' | translate
        }}</a>
        {{ ' ' }}<span class="trial-banner__text-light">{{ 'tenders.responses.trial-banner.text-expired-sub' | translate }}</span>
      </span>
    } @else {
      <span class="trial-banner__badge">{{ 'tenders.responses.trial-banner.badge' | translate: { plan: planLabel } }}</span>
      <span class="trial-banner__text">
        {{ 'tenders.responses.trial-banner.text-before-days' | translate: { plan: planLabel } }}
        <strong
          >{{ daysRemaining }}
          {{
            (daysRemaining === 1 ? 'tenders.responses.trial-banner.text-day' : 'tenders.responses.trial-banner.text-days') | translate
          }}</strong
        >,
        <a class="trial-banner__text-link" [href]="mailtoHref" target="_blank">{{
          'tenders.responses.trial-banner.cta-link' | translate
        }}</a>
        {{ ' ' }}<span class="trial-banner__text-light">{{ 'tenders.responses.trial-banner.text-after-days' | translate }}</span>
      </span>
    }
  </div>
}
